import StyleSheet from './StyleSheet'

export default StyleSheet
export { default as AppStyles, baseTheme, darkTheme, colorPalette } from './AppStyles'
export { legacyDarkTheme } from './LegacyAppStyles'
